export const PERMISSIONS = Object.freeze({
  BIG_BOSS: "BIG_BOSS",
  KYC_MANAGEMENT: "KYC_MANAGEMENT",
  ORDERS_ACCOUNT_ACCESS: "ORDERS_ACCOUNT_ACCESS",
  ORDERS_ACCOUNT_UPDATE: "ORDERS_ACCOUNT_UPDATE",
  ORDERS_BOOST_ACCESS: "ORDERS_BOOST_ACCESS",
  ORDERS_BOOST_UPDATE: "ORDERS_BOOST_UPDATE",
  ORDERS_CURRENCY_ACCESS: "ORDERS_CURRENCY_ACCESS",
  ORDERS_CURRENCY_UPDATE: "ORDERS_CURRENCY_UPDATE",
  ORDERS_ITEM_ACCESS: "ORDERS_ITEM_ACCESS",
  ORDERS_ITEM_UPDATE: "ORDERS_ITEM_UPDATE",
  ORDERS_GIFT_CARD_ACCESS: "ORDERS_GIFT_CARD_ACCESS",
  ORDERS_GIFT_CARD_UPDATE: "ORDERS_GIFT_CARD_UPDATE",
  ORDERS_SHOP_ACCESS: "ORDERS_SHOP_ACCESS",
  ORDERS_SHOP_UPDATE: "ORDERS_SHOP_UPDATE",
  GAME_ACCOUNTS_ACCESS: "GAME_ACCOUNTS_ACCESS",
  GAME_BOOST_ACCESS: "GAME_BOOST_ACCESS",
  GAME_CURRENCY_ACCESS: "GAME_CURRENCY_ACCESS",
  ADMIN: "ADMIN",
  STORES_MANAGER_ACCESS: "STORES_MANAGER_ACCESS",
  STOCKS_MANAGER_ACCESS: "STOCKS_MANAGER_ACCESS",
  AUTOMATIONS_WATCHDOG_CURRENCY: "AUTOMATIONS_WATCHDOG_CURRENCY",
  CURRENCY_PRICING_ACCESS: "CURRENCY_PRICING_ACCESS",
  AUTOMATIONS_WATCHDOG_ACCESS: "AUTOMATIONS_WATCHDOG_ACCESS",
  CHATS_ACCESS: "CHATS_ACCESS",
  AI_ASSISTANT_ACCESS: "AI_ASSISTANT_ACCESS",
  DEVELOPER: "DEVELOPER",
  CUSTOMER_SESSIONS: "CUSTOMER_SESSIONS",
});
